import { Rest, RestService } from './rest.service';
export const SERVICE_PROVIDERS = [RestService];

export { Rest, RestService };
